export enum PackagePermissions {
  ALL = "Travel:Packages:*",
  READ = "Travel:Packages:Read",
  WRITE = "Travel:Packages:Write",
}

export function hasPackageAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [PackagePermissions.READ, PackagePermissions.ALL, "*"].includes(p)
  );
}
